import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const AccordionContainer = ({
  title,
  icon,
  children,
  defaultExpanded = true,
}) => {
  return (
    <Accordion
      className="w-full !border-none !shadow-none !rounded-xl bg-white p-2"
      defaultExpanded={defaultExpanded}
      sx={{
        "&::before": {
          display: "none !important",
        },
        margin: 0,
        "&.Mui-expanded": {
          margin: 0,
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon className="text-blue-700" />}
      >
        <Box display="flex" alignItems="center" gap={1}>
          {icon}
          <Typography className="text-lg font-medium" variant="h2">
            {title}
          </Typography>
        </Box>
      </AccordionSummary>
      <AccordionDetails className="h-auto overflow-y-auto max-h-96">
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionContainer;
